<div class="offline-navigation">
  <div class="tab-list">
    @for (tab of detailsTab; track tab) {
      <div class='mobile-tab show-list' (click)='checkOnline(tab)' [ngClass]="{'active':selectedTab.name == tab.name, 'disabled': tab.disable}" >
        <div class='{{tab.logo}} display-icons'>&nbsp;</div>
        <div class='icon-name'>{{tab.name}}</div>
      </div>
    }
    @for (tab of detailsTab; track tab) {
      <div class='desk-tab show-list' (click)='changeTab(tab)' [ngClass]="{'active':selectedTab.name == tab.name,'disableIcon': tab.disable}" >
        {{tab.name}}
      </div>
    }
  </div>
</div>